import { render, staticRenderFns } from "./RaceTable.vue?vue&type=template&id=afe62b06&"
import script from "./RaceTable.vue?vue&type=script&lang=js&"
export * from "./RaceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports